// Devuelve los apartamentos de un edificio según la orden seleccionada
import { getToken } from './auth'
import { API_URL } from './config'
export async function getApartmentsByOrder(orderId) {
  try {
    const token = getToken();
    const res = await fetch(`${API_URL}/orders/${orderId}/apartments`, {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      let errorText = await res.text();
      console.error('Respuesta inesperada al listar apartamentos:', errorText);
      throw new Error('No se pudieron obtener los apartamentos. Respuesta inesperada: ' + errorText.slice(0, 200));
    }
    const data = await res.json();
    const apartments = Array.isArray(data.data) ? data.data.map(apartment => ({
      ...apartment,
      pests: Array.isArray(data.apartmentPests?.[apartment.id]) ? data.apartmentPests[apartment.id] : []
    })) : []

    return {
      apartments,
      contractedUnits: data.contractedUnits,
      apartmentPests: data.apartmentPests || {},
    };
  } catch (e) {
    console.error('Error en getApartmentsByOrder:', e);
    throw new Error(e.message || 'Error de conexión');
  }
}
